import styled from 'vue3-styled-components';

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const FormGroup = styled.div`
  margin-bottom: 16px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
`;

export const Input = styled.input`
  width: calc(100% - 24px);
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #0f4c5c;
    box-shadow: 0 0 0 2px rgba(15, 76, 92, 0.1);
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
  background-color: white;
  cursor: pointer;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #0f4c5c;
    box-shadow: 0 0 0 2px rgba(15, 76, 92, 0.1);
  }

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

export const ActionButton = styled.button`
  width: 100%;
  padding: 10px;
  background-color: #0f4c5c;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 16px;
  font-size: 14px;

  &:hover {
    background-color: #0d4352;
  }

  &:disabled {
    background-color: #ddd;
    cursor: not-allowed;
  }
`;

export const CategoryTree = styled.div`
  background: white;
  border-radius: 8px;
  height: calc(100% - 5px);
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #90a4ae;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #78909c;
  }
`;

export const TreeHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #e0e0e0;
  background: #ffffff;
  position: sticky;
  top: 0;
  z-index: 1;

  h3 {
    margin: 0;
    color: #0f4c5c;
    font-weight: 600;
    font-size: 20px;
  }
`;

export const CategoryItem = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  background: ${props => props.level === 1 ? '#f0f2f5' : 'white'};
  margin-left: ${props => props.level === 2 ? '24px' : '0'};
  transition: all 0.2s ease;

  &:hover {
    background: ${props => props.level === 1 ? '#e8eaf0' : '#f8f9fa'};
  }
`;

export const CategoryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CategoryInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ChevronButton = styled.button`
  background: none;
  border: none;
  padding: 6px;
  cursor: pointer;
  transition: transform 0.3s ease;
  transform: ${props => props.expanded ? 'rotate(180deg)' : 'rotate(0)'};
  color: #1976d2;
`;

export const CategoryName = styled.span`
  font-weight: 600;
  color: #2c3e50;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 15px;

  &:hover {
    background: rgba(15, 76, 92, 0.1);
  }
`;

export const CategoryActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const IconButton = styled.button`
  padding: 8px;
  border-radius: 4px;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  color: ${props => props.variant === 'delete' ? '#e53935' : '#1976d2'};
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${props => props.variant === 'delete' ? 'rgba(229, 57, 53, 0.1)' : 'rgba(25, 118, 210, 0.1)'};
    transform: ${props => props.variant === 'delete' ? 'rotate(90deg)' : 'scale(1.1)'};
  }
`;

export const SubCategories = styled.div`
  margin-left: 24px;
  border-left: 2px solid #1976d2;
  margin-top: 4px;
  margin-bottom: 4px;
`;

export const CategoryManageContainer = styled.div`
    display: flex;
    gap: 16px;
    height: 100%;
    width: 100%;
    padding: 10px;
    overflow: hidden;
`;

export const ValidationMessage = styled.div`
    margin-top: 4px;
    font-size: 12px;
    color: ${props => props.valid ? '#4caf50' : '#f44336'};
`;

export const CategoryAddSection = styled.div`
    flex: 0 0 200px;
    padding: 10px;
    border-radius: 8px;
    height: calc(100% - 32px);
    overflow: hidden;

    h3 {
        margin: 0 0 16px 0;
        color: #0f4c5c;
        font-size: 20px;
    }
`;

export const CategorySettingsSection = styled.div`
    flex: 1;
    overflow: hidden;
    padding: 10px;
    background: white;
    border-radius: 4px;
    box-shadow: 
        0 0 0 1px rgba(0, 0, 0, 0.05),
        0 1px 3px 0 rgba(0, 0, 0, 0.1),
        0 1px 2px -1px rgba(0, 0, 0, 0.1);
    margin-right: 15px;
`;

// ! 다이얼로그
export const InlineEditWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`;

export const InlineInput = styled.input`
  padding: 4px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 15px;
  min-width: 150px;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #4a90e2;
    box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
  }
`;

export const InlineActions = styled.div`
  display: flex;
  gap: 4px;
`;

export const SaveButton = styled(IconButton)`
  color: #4caf50;
  
  &:hover {
    background-color: rgba(76, 175, 80, 0.1);
  }
`;

export const CancelButton = styled(IconButton)`
  color: #f44336;
  
  &:hover {
    background-color: rgba(244, 67, 54, 0.1);
  }
`;